var map = {
	"./facebook-icon.svg": "e07a",
	"./instagram-icon.svg": "f6e3",
	"./linkedin-icon.svg": "c498",
	"./twitter-icon.svg": "1904",
	"./youtube-icon.svg": "85fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";